export default function navigation() {
    // var $contactbtn = $('.content-with-contact').find('a');

    $('.js-hamburger').on('click', function() {
        $('body').toggleClass('overflow');
        $('#mobile-nav').toggleClass('mobile--active');
    });

    $(window).on('load', function() {
        $('.js-update').velocity({
            opacity: 1
        }, {
            duration: 1000,
            easing: "ease-in-out"
        });
    });

    // $contactbtn.on('click', function(e) {
    //     $('html, body').animate({
    //         scrollTop: $("#js-contact-scroll-to").offset().top
    //     }, 1000);
    //     e.preventDefault();
    // });
}



// WEBPACK FOOTER //
// ./src/Resources/ui/js/navigation.js